import React from 'react'
// import ReactWhatsapp from "react-whatsapp";
import Navbar from '../inc/Navbar';
import Slider from '../inc/Slider';
import bethuaShowroom from "../images/Showroom.jpg";
import allviewshowroom from "../images/all view showroon.jpg";
import ScrollToTop from "react-scroll-to-top";
import ReactWhatsapp from "react-whatsapp";

import familyshopping from "../images/COMPLETE_FAMILY_SHOPPING with All model.jpg"
import familyshoppingNEW from "../images/COMPLETE_FAMILY_SHOPPING ADS New.jpg"
import "./Home.css";
import Products from './Products';
import SareeTrending from './SareeTrending';
import WeddingSaree from './WeddingSaree';


import weddingcompleteshopping from "../images/WEDDING_BALAJI SAREE model family 2.jpg";
import balajisareewedding from "../images/WEDDING_BALAJI SAREE Single model.jpg"
import FamilyShopping from './FamilyShopping';


function Home() {





  return (
    <div>
      <Navbar />

      <br />
      <br />
      <ScrollToTop smooth top="100" color="grey" />
      <div className="album py-0">
        <div className="container">
          <p><small>Balaji Saree</small></p>
        </div>
      </div>
      {/* <div style={{ color: "Green", display: 'flex', justifyContent: 'flex-start', margin: "2px",  }} className="fixed-bottom  mb-1"> <ReactWhatsapp number="+91  " className="circleb" message="I am intersted"> <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16">
        <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
      </svg>   </ReactWhatsapp> </div> */}


      <Slider />

      <div className='ranaghatsaree'>
        <div className="album py-0">
          <div className="container">

            <marquee>

              <h4 style={{ color: "#912222" }} className='mt-2'>"Welcome to Balaji Saree – Your destination for exquisite sarees | Explore our timeless beauty today!"
              </h4>
            </marquee>
          </div>
        </div>
      </div>



      <div className='colorbackground'>

        <Products />
        <br />
      </div>

      <div className="album py-0">
        <div className="container">
          <div className="row">
            <div className="col-md-6 mt-3">
              <img src={familyshopping} className="card-img-top" alt="familyshopping" />

            </div>
            <div className="col-md-6 mt-3">
              <img src={familyshoppingNEW} className="card-img-top" alt="familyshopping" />

            </div>
          </div>
        </div>

      </div>



      <div className="album py-2">
        <div className="container">
          <div className="row">
            <div className="col-md-6 mt-3">
              <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fp%2FBalaji-Saree-Official-61552987596973%2F&tabs=timeline&width=1000&height=700&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId" width="100%" height="429" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
            </div>
            <div className="col-md-6 mt-3">
<iframe src="https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2F61552987596973%2Fvideos%2F1466541657955668%2F&show_text=true&width=560&t=0" width="100%" height="429"  scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen="true"></iframe>
            </div>
          </div>
        </div>
      </div>
      <div className='balajisaree'>
        <div className="album py-4">
          <div className="container mt-2">
            <h1 style={{ color: "#CD0004" }}><b>BEST TRENDING SAREE EXPLORE </b></h1>
          </div>
        </div>
      </div>
      <div className='sareeback'>
        <SareeTrending />
      </div>

      <div className='balajisaree'>
        <div className="album py-4">
          <div className="container mt-2">
            <h1 style={{ color: "#CD0004" }}><b>Best Wedding Collection Explore  </b></h1>
          </div>
        </div>
      </div>
      <br />
      <WeddingSaree />

      <br />
      <hr />
      <div className='completeweddingcollection'>
        <div className="album py-3">
          <div className="container">
            <div className="row">
              <div className="col-md-6 mt-3">
                <div className='radius'>
                  <img src={weddingcompleteshopping} className="card-img-top" alt="weddingcompleteshopping" />
                </div>
              </div>
              <div className="col-md-6 mt-3">
                <div className='radius'>
                  <img src={balajisareewedding} className="card-img-top" alt="balajisareewedding" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <br/>
      </div>
<br/>
    <div className='balajisaree'>
        <div className="album py-4">
          <div className="container mt-2">
            <h1 style={{ color: "#CD0004" }}><b>Best Family Collection Explore  </b></h1>
          </div>
        </div>
      </div>
      <br />
      <FamilyShopping/>
      <div className="album py-2">
        <div className="container">
          <div className='borderradius'>
            <img src={allviewshowroom} className="d-block w-100" alt="Balaji Saree" />
          </div>
        </div>
      </div>
      <br />



      <div className="album py-0">
        <div className="container">
          <div className="row">
            <div className="col-md-8 mt-3">
              <div className="card-body">
                <div className='fashionstyle'>
                  <h5 className="card-title mb-3"> সর্ব ভারতীয় সাড়ী ও রেডিমেড পোশাকের বিপুল সম্ভার </h5>
                  <h3 className="card-text mb-3"> আমরা শাড়ি মানুফ্যাকচারার</h3>
                </div>
                <div className="d-flex justify-content-start align-items-center mb-2">
                  <a href="Ranaghat_showroom" className="bethua me-2">Ranaghat <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                  </svg></a>
                  <a href="Bethuadahari_showroom" className="bethua">Bethuadahari <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                  </svg></a>
                </div>
              </div>
            </div>
            <div className="col-md-4 mt-3">
              <img src={bethuaShowroom} className="card-img-top" alt="bethuaShowroom" />

            </div>
          </div>
        </div>
      </div>
      <br />
      <br />

    </div>
  )
}

export default Home